module.exports = __webpack_public_path__ + "build/img/record.a6d7bf76.png";